import { BaseResourceModel } from '../../models/base-resource.model';
import { LiquidacaoResto } from './liquidacao-resto.model';

// tslint:disable: variable-name

export class LiquidacaoRestoIsencaoReinf extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo?: number,
        public valor_isento?: number,
        public descricao?: string,
        public data_laudo?: string,
        public liquidacao_resto?: LiquidacaoResto,
    ) {
        super();
    }

    static converteJson(json: any): LiquidacaoRestoIsencaoReinf {
        return Object.assign(new LiquidacaoRestoIsencaoReinf(), json);
    }
}
